<template>
  <div>
    <div v-for="(promo, index) in promotions" :key="index">
      <component :is="getComponent(promo.RuleType)" :promo="promo" @delete="handleDelete(index)" @edit="handleEdit(index)" />
    </div>
  </div>
</template>

<script>
import RuleType1 from './rules/RuleType1.vue'
import RuleType2 from './rules/RuleType2.vue'
import RuleType3 from './rules/RuleType3.vue'

export default {
  props: {
    promotions: {
      type: Array,
      required: true
    }
  },
  components: {
    RuleType1,
    RuleType2,
    RuleType3
  },
  methods: {
    getComponent(ruleType) {
      switch (Number(ruleType)) {
        case 1: return 'RuleType1'
        case 2: return 'RuleType2'
        case 3: return 'RuleType3'
        default: return null
      }
    },
    handleDelete(index) {
      this.$emit('delete', index);
    },
    handleEdit(index) {
      this.$emit('edit', index);
    }
  }
}
</script>